import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState }) => css`
    min-width: 30px;
    height: ${displayState?.small ? '12px' : '16px'};
    border-radius: 12px;
    background: ${({ value, theme }) => value ? (theme?.colour?.primary ?? "#1DBD6B") : '#E3E3E3'};
    position: relative;
    cursor: pointer;

    &:after {
      content: " ";
      position: absolute;
      top: 2px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #FFF;
      transition: left 0.3s;
      left: ${({ value }) => value ? '14px' : '3px'};
    }

    @media only screen and (min-width: 768px) {
      min-width: ${displayState?.small ? '20px' : '40px'};
      height: ${displayState?.small ? '12px' : '24px'};

      &:after {
        top: ${displayState?.small ? '2px' : '4px'};
        width: ${displayState?.small ? '8px' : '16px'};
        height: ${displayState?.small ? '8px' : '16px'};
        left: ${({ value, displayState }) => value ? (displayState?.small ? '10px' : '20px') : (displayState?.small ? '2px' : '4px')};
      }
    }
  `}
`;


export default Atom({ type: 'toggle', template })